module.exports = __webpack_public_path__ + "static/media/fusion_mobile_assets_new.a87f7911.png";